import { render, staticRenderFns } from "./bxDcUserConf.vue?vue&type=template&id=6b70e5ca&scoped=true&"
import script from "./bxDcUserConf.vue?vue&type=script&lang=js&"
export * from "./bxDcUserConf.vue?vue&type=script&lang=js&"
import style0 from "./bxDcUserConf.vue?vue&type=style&index=0&id=6b70e5ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b70e5ca",
  null
  
)

export default component.exports